import { render, staticRenderFns } from "./BlockGridUser.vue?vue&type=template&id=40082bcb&scoped=true&"
import script from "./BlockGridUser.vue?vue&type=script&lang=js&"
export * from "./BlockGridUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockGridUser.vue?vue&type=style&index=0&id=40082bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40082bcb",
  null
  
)

export default component.exports